__turbopack_context__.v({
  "appCard": "ConnectedAppsDialog-module__b-mrTG__appCard",
  "appIconContainer": "ConnectedAppsDialog-module__b-mrTG__appIconContainer",
  "appImage": "ConnectedAppsDialog-module__b-mrTG__appImage",
  "appInfo": "ConnectedAppsDialog-module__b-mrTG__appInfo",
  "appsGrid": "ConnectedAppsDialog-module__b-mrTG__appsGrid",
  "dialogContent": "ConnectedAppsDialog-module__b-mrTG__dialogContent",
});
